import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, DashboardModuleListItem, Image, Text,
} from '@domain-group/suit-theme'

import useSavedArtworkPage from '@hooks/useSavedArtworkPage'

import { SavedArtworkPageModel } from '@models/savedArtworkPage'

import placeholderImageUrl from '../../../../../../assets/placeholder.svg'

type SavedArtworkPageListItemProps = {
  entity: SavedArtworkPageModel,
}

const SavedArtworkPageListItem = (props: SavedArtworkPageListItemProps) => {
  const { entity: savedArtworkPage } = props

  const {
    callbacks: { launchManageSavedArtworkPageModal },
    savedArtwork,
    user,
  } = useSavedArtworkPage(savedArtworkPage)

  const { title } = savedArtworkPage
  const { title: savedArtworkTitle } = savedArtwork || {}

  const createdDateTime = digObject(savedArtworkPage, 'dates.created.date_time')
  const thumbUrl = digObject(savedArtworkPage, 'previews.thumb', '')

  const createdDateTimeFormatted = DateTime.fromFormat(
    createdDateTime,
    'dd/MM/yyyy HH:mm',
  ).toFormat('h:mm a dd/MM/yyyy ')

  return (
    <DashboardModuleListItem
      imageComponent={(
        <Image
          backgroundSize="contain"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          forwardProps={{ backgroundColor: 'whiteGrey' }}
          placeholderUrl={placeholderImageUrl}
          url={thumbUrl}
        />
      )}
      onClick={() => launchManageSavedArtworkPageModal()}
      secondaryText={`${user.full_name || ''} ${createdDateTimeFormatted}`}
      // @ts-expect-error TS2322
      showAngleIcon
      title={title}
    >
      <Box flexDirection="column">
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.TertiaryText>
          <Box flexDirection="column" textAlign="right" fontSize="xsmall">
            <Text>{`Saved Page #${savedArtworkPage.id}`}</Text>

            {savedArtworkTitle && (
              <Text color="bodyFontLightColor" marginTop="small">{`Saved In: ${savedArtworkTitle}`}</Text>
            )}
          </Box>
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      </Box>
    </DashboardModuleListItem>
  )
}

export default SavedArtworkPageListItem
